import * as React from 'react';
import { Box, NotificationColumn } from './Notification.style';
import { Col } from 'reactstrap';
import NotificationButton from './NotificationButton/NotificationButtonComponent';
import NotificationMessage from './NotificationMessage/NotificationMessageComponent';

export const NotificationComponent = ({
  notifications = [],
  dismissNotification
}) => (
  <NotificationColumn>
    {notifications.map(({ category, title, messages }, index) => (
      <Box key={index}>
        <Col sm={12}>
          <NotificationMessage
            category={category}
            title={title}
            messages={messages}
          />
        </Col>
        <Col sm={12}>
          <NotificationButton
            category={category}
            onClickHandler={() => dismissNotification(index)}
          />
        </Col>
      </Box>
    ))}
  </NotificationColumn>
);

export default NotificationComponent;



// WEBPACK FOOTER //
// ./src/components/common/Notification/NotificationComponent.js